// js
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
/*eslint import/namespace: ['error', { allowComputed: true }]*/
import * as colors from '../../constants/colors';
// css
import '../../styles/components/common/ProgressBar.scss';

/**
 * div-based progress bar (no labels)
 */
const ProgressBar = ({
  percent = 0,
  stripeColor = 'black',
  stripeSize = 12,
  width = '100%',
  height = 17,
  backgroundColor = 'blue',
  greyOnZero = false
}) => {

  const barWidth = (100 * percent) + '%';
  const barClasses = classNames({
    'progress-bar__bar': true,
    'progress-bar__bar--complete': percent === 1.0
  });
  const backgroundStyles = {
    height: height + 'px',
    width: width,
    backgroundColor: greyOnZero && percent === 0 ? colors.grey : undefined
  };
  const barStyles = {
    width: barWidth,
    background: `repeating-linear-gradient(
      45deg,
      ${stripeColor},
      ${stripeColor} ${height / stripeSize}px,
      ${colors[backgroundColor]} ${height / stripeSize}px,
      ${colors[backgroundColor]} ${height / (stripeSize / 2)}px)`
  };

  return (
    <div className='progress-bar'>
      <div className='progress-bar__background' style={backgroundStyles}>
        <div className={barClasses} style={barStyles} />
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  percent: PropTypes.number,
  stripeColor: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.number,
  backgroundColor: PropTypes.string,
  greyOnZero: PropTypes.bool,
  stripeSize: PropTypes.number
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/common/ProgressBar.js